import React from "react";
import BuyukcekmeceSidebar from "../Sidebar/BuyukcekmeceSidebar";
import BuyukcekmeceOtherServices from "../ServiceAreas/BuyukcekmeceServiceArea";
// import BadgeSection from "../../BadgeSection";
import LeftSidebar from "../../Sidebars/LeftSidebar";
import RightSidebar from "../../Sidebars/RightSidebar";

const BuyukcekmeceIntro = () => {
  return (
    <div className="bg-white text-black py-10 px-4 max-w-screen-xl mx-auto">
      <h1 className="mt-0 text-2xl text-center font-bold text-[#003132] mb-4">
        BÜYÜKÇEKMECE HALI-KOLTUK YIKAMA
      </h1>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        {/* İçerik */}
        <div className="order-1 md:order-2 md:col-span-2 space-y-6">
          <p>
            Büyükçekmece bölgesinde halı ve koltuk yıkama hizmeti, hijyen ve konforu bir arada sunar. Geniş servis ağımız sayesinde, Mimarsinan’dan Atatürk Mahallesi’ne kadar her mahallede temizlik hizmetimizi ulaştırıyoruz.
          </p>

          <p>
            Halılarınız modern makinelerimizle özel programlarda yıkanır. Önce toz alma, ardından leke çıkarma, durulama, kurutma ve paketleme işlemleri profesyonel adımlarla gerçekleştirilir. Koltuk yıkamada ise yerinde hizmet seçeneğimizle evinizi kirletmeden buhar teknolojisi ve özel kimyasallarla detaylı temizlik sağlıyoruz.
          </p>

          <p>
            <strong>Büyükçekmece'deki halı-koltuk yıkama hizmetimizin sunduğu avantajlar:</strong>
          </p>

          <ul className="list-disc list-inside">
            <li>Büyükçekmece’nin tüm mahallelerinden ücretsiz alım ve teslimat</li>
            <li>7/24 ulaşılabilir destek ve hızlı randevu sistemi</li>
            <li>Yün, el dokuması ve shaggy gibi özel halılara uygun yıkama metotları</li>
            <li>Yerinde koltuk yıkama: minimal temizlik, maksimum hijyen</li>
            <li>Yorgan, battaniye, stor ve tül perde yıkama hizmetleri</li>
            <li>Hijyenik ortamda kurutma ve steril paketleme</li>
          </ul>

          <p>
            Fatih Mahallesi, Cumhuriyet, Güzelce, Kumburgaz ve Tepecik dahil olmak üzere tüm mahallelerde hizmet veriyoruz. Araçlarımız gün içerisinde kapınıza kadar gelip halılarınızı teslim alır ve yıkama işlemi tamamlandıktan sonra özenle geri getirir.
          </p>

          <p>
            Firmamız, müşteri memnuniyetini en üst seviyede tutmayı amaçlar. Temizliğin sadece görünürde değil, mikroskobik düzeyde de tam olması gerektiğine inanıyoruz. Bu yüzden tüm ürünleriniz anti-bakteriyel çözümlerle işlem görür.
          </p>

          <p>
            Büyükçekmece’de güvenilir, hijyenik ve profesyonel halı-koltuk yıkama arıyorsanız hemen bize ulaşabilirsiniz. Online sipariş ve hızlı servis seçeneklerimizle hizmetinizdeyiz.
          </p>

          {/* Mahalle sidebar ve hizmet bölgeleri */}
          <BuyukcekmeceSidebar />
          <BuyukcekmeceOtherServices />
        </div>

        {/* Sol Sidebar */}
        <div className="order-2 md:order-1 space-y-6">
          <LeftSidebar />
        </div>

        {/* Sağ Sidebar */}
        <div className="order-3 md:order-3 space-y-6">
          <RightSidebar />
        </div>
      </div>
    </div>
  );
};

export default BuyukcekmeceIntro;
